module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGfa53c4b46878252aa9175978d7823d86.fa53c4b4.png";